// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/shared/minimizeButtonToggle/minimizeButtonToggle.component.scss
// module id = 295
// module chunks = 0 1